import { GoogleIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";

export default function () {
  return (
    <div
      style={{ viewTransitionName: "nav-transition-admin-login" }}
      className="flex items-center justify-center w-full outline h-screen"
    >
      <div className="flex flex-col p-4 gap-4 rounded-md border">
        <div className="flex flex-col justify-center items-center text-primary">
          <img src="/logo-light.svg" className="h-40 object-contain" />
        </div>
        <Button asChild>
          <a href="/admin/gauth">
            <GoogleIcon className="size-5 md:size-7 fill-background" />
            Iniciar sesión con Google
          </a>
        </Button>
      </div>
    </div>
  );
}
